import { identifyUser } from '@kcd/event-tracker';

import { useOAIQuery } from '~/hooks/reactQuery';
import { fetchOAIData } from '~/libs/openapi';
import type { RequiredOAISchema } from '~/types/openapi';

import { getSnowdonJwt } from './utils';

export function useCurrentUser() {
  const { data: user, ...props } = useOAIQuery({
    queryKey: '/api/market-place/v1/buyer',
    queryOptions: {
      // AppHooks에서 전역적으로 체크하는 로직이므로 suspense를 동시에 두곳에서 사용될 경우 둘다 suspense가 걸릴 수 있음
      // 그래서 false로 유지
      suspense: false,
      keepPreviousData: true,
      onSuccess: (data) => {
        identifyUser(data.trackingId as string, {
          name: data.name,
          publicUserId: data.uuid,
        });
      },
    },
  });

  // jwt가 있을 때에는 account가 항상 존재하겠지만, jwt가 없거나 에러가 나면 undefined일 수 있음
  return {
    ...props,
    user: user as RequiredOAISchema<'MarketBuyerResponse'> | undefined,
    isLoggedIn:
      user?.loginType === 'NORMAL' || user?.loginType === 'PRE_BUSINESS',
  };
}

//  /buyer api와 동일 조건
export const useCurrentUserPlusMembership = () => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/buyer/plus-membership',
    queryOptions: {
      keepPreviousData: true,
      suspense: true,
    },
  });
};

export async function fetchCurrentUser(
  fetchOptions = {},
): Promise<RequiredOAISchema<'MarketBuyerResponse'>> {
  // eslint-disable-next-line no-return-await
  return await fetchOAIData({
    queryKey: '/api/market-place/v1/buyer',
    fetchOptions: {
      headers: {
        'X-Client-Auth-Token': getSnowdonJwt(),
      },
      ...fetchOptions,
    },
  });
}

/**
 * @description /mypage 에 노출될 정보를 받는 api
 * */
export const useCurrentUserMyPage = () => {
  const { data } = useOAIQuery({
    queryKey: '/api/market-place/v1/buyer/my-page',
  });

  return data;
};
